import React from "react";

import { useLocation } from "react-router-dom";

export function useQuery() {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
}

export function getPathSegment(pathname: string, index = 1) {
  if (typeof pathname !== 'string' || pathname.trim() === '') {
    console.warn('Invalid pathname provided.');
    return null;
  }

  const segments = pathname
    .split('/')
    .map(s => s.trim())
    .filter(Boolean);

  return segments[index] ?? null;
}